// The guided path: screens the route picks for the player, where the way on is the screen's own
// button and the screen tabs (`ShellNav`), the brand's jump to the title and the menu's "World screen"
// stand down. A tab there would only fight the RouteDriver (a fight the party is in pulls the route
// straight back; a Spoils screen left early skips its division), so it is hidden rather than refused.
//
// - The opening (docs/21): the writing screen, the intro (not a replay from the Saga), the first
//   battle, its Spoils screen and the epilogue. The intro's "Skip the opening" and the HUD's
//   "Abandon room" are the situational ways out; the menu keeps Leave World, Title screen and Sign out.
// - Any fight the player's party is in (its HUD has Abandon room), and every Spoils screen (Continue).
// A fight watched from outside the party, the World, lobbies, maps and the Aftermath keep their tabs.
import { useRoute } from '../core/stores/route';
import { useSession } from '../core/stores/session';
import { useEncounterRow, useParties, useWorldOpening } from '../core/subscriptions/hooks';

const ENC_ENDED = 3;

export function useGuided(): boolean {
  const screen = useRoute((s) => s.screen);
  const replay = useRoute((s) => s.replay);
  const partyId = useRoute((s) => s.partyId);
  const encounterId = useRoute((s) => s.encounterId);
  const worldId = useSession((s) => s.worldId);
  const opening = useWorldOpening(worldId);
  const party = useParties(worldId).find((p) => p.id === partyId);
  const enc = useEncounterRow(screen === 'encounter' ? encounterId : undefined);
  if (!worldId) return false;
  switch (screen) {
    case 'writing': case 'epilogue': case 'spoils': return true;
    case 'intro': case 'chapter': return !replay;
    case 'encounter':
      if (encounterId === undefined) return false;
      return encounterId === opening?.encounterId || encounterId === party?.encounterId || enc?.state === ENC_ENDED;
    default: return false;
  }
}
